export const messages = {
  en: {
    supplierTypeManage: {
      search: {
        title: 'Search Conditions',
        typeCd: 'Please enter type code',
        typeName: 'Please enter type name'
      },
      list: {
        title: 'Supplier Type List'
      },
      table: {
        typeCd: 'Type Code',
        typeName: 'Type Name',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      form: {
        typeCd: 'Type Code',
        typeName: 'Type Name',
        remark: 'Remark'
      },
      placeholder: {
        typeCd: 'Please enter type code',
        typeName: 'Please enter type name',
        remark: 'Please enter remark'
      },
      validate: {
        typeCdRequired: 'Type code is required',
        typeCdMaxLength: 'Type code cannot exceed 32 characters',
        typeNameRequired: 'Type name is required',
        typeNameMaxLength: 'Type name cannot exceed 255 characters',
        remarkRequired: 'Remark is required',
        remarkMaxLength: 'Remark cannot exceed 512 characters',
        stIdRequired: 'ID is required'
      },
      message: {
        addSuccess: 'Add success',
        editSuccess: 'Edit success',
        deleteSuccess: 'Delete success',
        fetchError: 'Failed to fetch data'
      },
      fetchError: 'Failed to fetch supplier type data',
      add: {
        title: 'Add Supplier Type'
      },
      edit: {
        title: 'Edit Supplier Type'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this supplier type?'
      },
      page: {
        subtitle: 'Maintain supplier type codes, names and remarks',
        empty: 'No supplier type data',
        loadFailed: 'Failed to load supplier type list'
      }
    }
  },
  zh: {
    supplierTypeManage: {
      search: {
        title: '查询条件',
        typeCd: '请输入类型编码',
        typeName: '请输入类型名称'
      },
      list: {
        title: '供应商类型'
      },
      table: {
        typeCd: '类型编码',
        typeName: '类型名称',
        createTime: '创建时间',
        remark: '备注'
      },
      form: {
        typeCd: '类型编码',
        typeName: '类型名称',
        remark: '备注'
      },
      placeholder: {
        typeCd: '请输入类型编码',
        typeName: '请输入类型名称',
        remark: '请输入备注'
      },
      validate: {
        typeCdRequired: '类型编码不能为空',
        typeCdMaxLength: '类型编码不能超过32个字符',
        typeNameRequired: '类型名称不能为空',
        typeNameMaxLength: '类型名称不能超过255个字符',
        remarkRequired: '备注不能为空',
        remarkMaxLength: '备注不能超过512个字符',
        stIdRequired: '编号不能为空'
      },
      message: {
        addSuccess: '添加成功',
        editSuccess: '修改成功',
        deleteSuccess: '删除成功',
        fetchError: '获取数据失败'
      },
      fetchError: '获取供应商类型数据失败',
      add: {
        title: '添加供应商类型'
      },
      edit: {
        title: '修改供应商类型'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除该供应商类型吗？'
      },
      page: {
        subtitle: '维护供应商类型编码、名称与备注',
        empty: '暂无供应商类型数据',
        loadFailed: '获取供应商类型列表失败'
      }
    }
  }
}